import React, { useState } from "react";
import { ArrowRight, Mail, Phone } from "lucide-react";
import "./CO93110.scss";

// ============================================================================
// DATA
// ============================================================================

const PRODUCT_CATEGORIES = [
  "Hospitality (HMS)",
  "Education (Academic Portal)",
  "CRM",
  "Accounting",
  "Swift Grid Email API",
  "Team Chat",
  "Something else",
];

// ============================================================================
// COMPONENT
// ============================================================================

const CO93110: React.FC = () => {
  const [category, setCategory] = useState("");
  const [product, setProduct] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  return (
    <div className="wrap">
      {/* HERO BAND */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-copy">
            <h1>Contact us</h1>
            <p className="hero-sub">
              Call, email, or send us a message below — a Cilpron
              representative will get back to you directly.
            </p>
            <div className="hero-buttons">
              <a className="btn-dark" href="tel:+2348122221040">
                <Phone size={16} /> Call Cilpron Sales
              </a>
              <a className="btn-outline" href="mailto:support@cilpron.com">
                <Mail size={16} /> Email Cilpron Support
              </a>
            </div>
          </div>
          <div className="hero-photo">
            <img
              src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=900&q=80&auto=format&fit=crop"
              alt="Colleagues talking in an office hallway"
            />
          </div>
        </div>
      </section>

      {/* CONTACT OPTIONS ROW */}
      <section className="options-section">
        <div className="options-row">
          <div className="option-col">
            <span className="option-icon">
              <Phone size={26} strokeWidth={1.5} />
            </span>
            <h3>Call Cilpron Sales</h3>
            <p>Speak with a representative directly.</p>
            <a className="option-link plain" href="tel:+2348122221040">
              +234 812 222 1040
            </a>
          </div>

          <div className="option-col">
            <span className="option-icon">
              <Mail size={26} strokeWidth={1.5} />
            </span>
            <h3>Email Cilpron Sales</h3>
            <p>Send us a note and we'll reply from a real inbox.</p>
            <a className="option-link plain" href="mailto:support@cilpron.com">
              support@cilpron.com
            </a>
          </div>

          <div className="option-col">
            <span className="option-icon">
              <ArrowRight size={26} strokeWidth={1.5} />
            </span>
            <h3>Send a detailed message</h3>
            <p>
              Tell us which product you're interested in and we'll route it
              to the right team.
            </p>
            <a className="option-link" href="#send-message">
              Fill out the form below
            </a>
          </div>
        </div>
      </section>

      {/* SEND A MESSAGE FORM */}
      <section className="form-section" id="send-message">
        <div className="form-inner">
          <h2>How can we help?</h2>

          <div className="form-card">
            <h3>Send a message to Cilpron Sales</h3>
            <p>
              Select the product you're interested in. You'll then be
              prompted to provide your contact details and a message. Once
              you send those, a sales representative will contact you.
            </p>

            <div className="select-field">
              <label htmlFor="category">Product category</label>
              <select
                id="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Please select a product category</option>
                <option value="industry">By industry</option>
                <option value="product">By product</option>
              </select>
              <span className="field-required">Required</span>
            </div>

            <div className="select-field">
              <label htmlFor="product">Product</label>
              <select
                id="product"
                value={product}
                onChange={(e) => setProduct(e.target.value)}
              >
                <option value="">Please select a product</option>
                {PRODUCT_CATEGORIES.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </select>
              <span className="field-required">Required</span>
            </div>

            <div className="text-field-row">
              <div className="text-field">
                <label htmlFor="name">Your name</label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Jane Doe"
                />
                <span className="field-required">Required</span>
              </div>

              <div className="text-field">
                <label htmlFor="email">Your email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="jane@company.com"
                />
                <span className="field-required">Required</span>
              </div>
            </div>

            <div className="text-field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                rows={5}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Tell us a bit about what you're looking for..."
              />
              <span className="field-required">Required</span>
            </div>

            <button className="btn-dark">
              Submit <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CO93110;